import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const HeadingStyle = styled(Box)({
  textAlign: 'center',
});
